<template>
  <div>
   <!--
    <CRow>
      <CCol sm="12">
        <div class="form-group">
          <label>Nhân viên</label>
          <CInput
            v-model="searchData.name"
            :placeholder="this.$t('placeholder.label_enter_name_seat')"
            v-on:keyup.enter="search"
          />
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" class="btn-search text-center">
        <CButton class="btn-search-employee" @click.prevent="search">{{
          $t("button.label_employee_btn_search")
        }}</CButton>
        <CButton class="btn-reset" @click="resetForm">{{
          $t("button.label_action_reset")
        }}</CButton>
      </CCol>
    </CRow>
   -->
    <CRow>
      <CCol md="12">
        <div
          style="
            height: 500px;
            width: 740x;
            padding: 10px;
            border: 1px solid gray;
            position: relative;
          "
        >
          <vue-draggable-resizable
            v-for="(element, index) in listSeatEmployee"
            :key="index"
            :parent="false"
            :resizable="false"
            :draggable="false"
            :hidden="false"
            :x="element.x"
            :y="element.y"
            class="dnd-table"
            :w="element.width"
            :h="element.height"
            @dragstop="onDrag"
            @resizestop="onResize"
            @activated="onActivated(element, index)"
            :style="{ background: element.color }"
          >
            <p>{{ element.name }}</p>
          </vue-draggable-resizable>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { mapActions } from "vuex";

export default {
  name: "LayoutSeat",
  components: {
    VueDraggableResizable,
  },
  props: {
    listSeatEmployee: {
      type: Array,
      default: () => [],
    },
    getAllEmployee: {
      type: Object,
      default: () => {},
    },
    floors: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      index: null,
      width: 0,
      height: 0,
      item: {},
      select: "",
      idTable: "",
      myValue: "",
      selected: [],
      searchData: {
          name: ""
      }
    };
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    // resetForm() {
    //     this.searchData.name = ""
    // }
  },
};
</script>
<style lang="scss">
.seat {
  border: 1px solid gray;
  padding: 10px;
  margin-bottom: 30px;
  box-shadow: 0px 4px 8px 0;
}
.title {
  text-align: center;
  padding-bottom: 15px;
}
.dnd-table {
  border: 1px solid;
  text-align: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.btn-edit {
  margin: 15px 0 15px 90px;
}
.btn-submit {
  padding: 20px 0 10px 0;
  text-align: center;
}
.btn-save {
  margin-right: 15px;
}
.info {
  text-align: center;
}
.info-value {
  padding-top: 15px;
}
.action {
  padding: 0 15px 15px 0;
}
.btn-addbox {
  margin-right: 15px;
}
.list-employee {
  border: 1px solid gray;
  margin: 20px 0;
}
.label-list {
  padding: 10px 0 0 20px;
}
.check-box {
  display: flex;
  text-align: center;
  padding: 5px 5px 10px 3px;
}
.employee-table {
  margin: 15px 5px;
  .cl-pointer {
    cursor: pointer;
    .icon-sort {
      margin-left: 5px;
      .c-icon {
        width: 12px;
      }
      .sort-rotate {
        transform: rotate(180deg);
      }
    }
  }
}
th,
td {
  vertical-align: middle !important;
}
@media only screen and (max-device-width: 767px) {
  .employee-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1500px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .employee-table {
    margin: 1rem;
  }
  .table-tablet {
    width: 1500px;
    overflow-x: scroll;
  }
}
</style>
